import { render } from "./trumpetFTConsumptionDetails.vue?vue&type=template&id=76e196c8&scoped=true"
import script from "./trumpetFTConsumptionDetails.vue?vue&type=script&lang=js"
export * from "./trumpetFTConsumptionDetails.vue?vue&type=script&lang=js"

import "./trumpetFTConsumptionDetails.vue?vue&type=style&index=0&id=76e196c8&scoped=true&lang=css"
import "./trumpetFTConsumptionDetails.vue?vue&type=style&index=1&id=76e196c8&lang=css"
script.render = render
script.__scopeId = "data-v-76e196c8"

export default script